import * as React from 'react';
import { NavLink } from 'react-router-dom';
const classNames = require('classnames');
import { SecurityRoles as roles } from '../../common/utils';

interface Props {
	to?: string;
	onClick?: (e?: any) => any;
	onFocus?: (e?: any) => any;
	onBlur?: (e?: any) => any;
	className?: string;
	linkClassName?: string;
	linkDataFlyout?: string;
	linkExactActive?: boolean;
	rolesRequired?: Array<roles>;
	currentRoles?: Array<roles>;
	children?: {};
}

const NavItem: React.StatelessComponent<Props> = originalProps => {
	const {
		to,
		onClick,
		onFocus,
		onBlur,
		className,
		linkClassName,
		linkDataFlyout,
		linkExactActive,
		children,
		rolesRequired,
		currentRoles
	} = originalProps;
	// authorized if current roles contains 1 or more required roles
	// or if no roles are required, or if no roles required and no current roles
	const isAuthorized =
		!Array.isArray(rolesRequired) ||
		rolesRequired.length === 0 ||
		rolesRequired.some(role => Array.isArray(currentRoles) && currentRoles.indexOf(role) >= 0);

	return isAuthorized ? (
		<li className={classNames('nav-item', className)}>
			{to && onClick ? (
				<NavLink
					to={to}
					onClick={onClick}
					onFocus={onFocus}
					onBlur={onBlur}
					activeClassName="active"
					className={classNames('nav-link', linkClassName)}
					data-flyout={linkDataFlyout}
					exact={linkExactActive}
				>
					<span className="nav-link-label">{children}</span>
				</NavLink>
			) : (
				<span className="nav-heading">{children}</span>
			)}
		</li>
	) : null;
};

export default NavItem;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/navigation/NavItem.tsx